import Swal from "sweetalert2";
import Api from "shared/service/api/api";
export default class Helpers {
  /**
   *
   * @param {Array.<object>} arr
   * @param {string} key
   * @returns sorted array
   */
  static sortByKey(arr, key = "date") {
    return arr.sort((a, b) => {
      if (a[key] > b[key]) {
        return -1;
      }

      if (a[key] < b[key]) {
        return 1;
      }

      return 0;
    });
  }

  /**
   * Replaces nulls and zeros with empty string in values of object list.
   * @param {Array.<object>} list
   */
  static zerosToEmptyStrs(list) {
    list.map((el) => {
      for (var key in el) {
        el[key] = !el[key] || el[key] == 0 || el[key] == "0.00" ? "" : el[key];
      }
    });
  }

  /**
   *
   * @param {number} payout_request_id
   * @param {object} options Swal options
   */
  static showReceiptRequiredMsg(payout_request_id, options) {
    Swal.fire({
      confirmButtonText: "Отправить",
      input: "text",
      inputAttributes: {
        placeholder: "Ссылка на чек",
      },
      icon: "warning",
      ...options,
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        Api.account.payout.saveReceipt(payout_request_id, result.value);
      }
    });
  }

  /**
   * Возвращает строку, состоящую из числительного и слова в правильном падеже
   * @param {int} num числительное
   * @param {Object} wordCases `{'1' => 'им. падеж ед. числа', '2-3-4' => 'вин. падеж мн. числа', 'else' => 'род. падеж мн. числа'}`
   */
  static getWordCaseByNum(num, wordCases) {
    let lastToDigits = num % 100;
    if (lastToDigits > 20) {
      lastToDigits %= 10;
    }

    if (lastToDigits === 1) {
      return `${num} ${wordCases['1']}`;
    } else if ([2, 3, 4].includes(lastToDigits)) {
      return `${num} ${wordCases['2-3-4']}`;
    } else {
      return `${num} ${wordCases['else'] || wordCases['2-3-4']}`;
    }
  }
}
